var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.noDocuments
        ? _c(
            "div",
            { staticClass: "collapsee-body d-flex align-items-center" },
            [
              _c("img", {
                staticStyle: {
                  filter: "opacity(0.4)",
                  width: "40px",
                  height: "40px",
                },
                attrs: {
                  alt: _vm.$t("global.words.dragAndDrop"),
                  src: require("@Shared/@Assets/img/drag-and-drop.png"),
                },
              }),
              _vm._v(" "),
              _c("span", { staticClass: "text-light-gray ml-2" }, [
                _vm._v(_vm._s(_vm.$t("documents.dragAndDropDocuments"))),
              ]),
            ]
          )
        : _vm._l(_vm.documents.byId, function (document) {
            return _c("document-row", {
              key: document.documentId,
              attrs: {
                "application-id": _vm.applicationId,
                "client-username": _vm.clientUsername,
                document: document,
                comments: _vm.getCommentsForDocument(document.documentId),
              },
              on: {
                "open-tags": function ($event) {
                  return _vm.$emit("open-tags", $event)
                },
              },
            })
          }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }